/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';
import {QuestionnaireResponsesSummaryModel} from "../../models/questionnaire-responses-summary-model";
import { Gender } from '../../../enums/gender';
import { Ethnicity} from '../../../enums/ethnicity';

export interface SummaryFilters {
    startDate: string | null;
    endDate: string | null;
    minAge: number | null;
    maxAge: number | null;
    selectedGenders: Gender[];  // Explicitly typed as an array of Gender enums
    selectedEthnicities: Ethnicity[];  // Explicitly typed as an array of Ethnicity enums
}

export interface AnalyticsResponsesSummaryGetParams {
    questionnaireGuid: string;
    version?: number | undefined;
    StartDate?: string;
    EndDate?: string;
    Ethnicities?: string[];
    Genders?: string[];
    MinAge?: number;
    MaxAge?: number;
    // Add an index signature to allow dynamic assignment of keys
    [key: string]: string | number | string[] | undefined;  // Allows any key with valid value types
}

export function analyticsResponsesSummaryGet(http: HttpClient, rootUrl: string, params: AnalyticsResponsesSummaryGetParams, headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<QuestionnaireResponsesSummaryModel>> {
    const rb = new RequestBuilder(rootUrl, analyticsResponsesSummaryGet.PATH, 'get');
    for (let headerKey of headers.keys()) {
        rb.header(headerKey, headers.get(headerKey));
    }

    rb.path('questionnaireGuid', params.questionnaireGuid, {"style":"simple"});

    // Optional filter parameters
    if (params.StartDate) rb.query('StartDate', params.StartDate);
    if (params.EndDate) rb.query('EndDate', params.EndDate);
    if (params.MinAge !== undefined) rb.query('MinAge', params.MinAge);
    if (params.MaxAge !== undefined) rb.query('MaxAge', params.MaxAge);
    if (params.Genders?.length) {
        rb.query('Genders', params.Genders);
    }
    if (params.Ethnicities?.length) {
        rb.query('Ethnicities', params.Ethnicities);
    }

    if (params.version) {
        rb.query('version', params.version);
    }

    return http.request(
        rb.build({ responseType: 'json', accept: '*/*', context })
    ).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<QuestionnaireResponsesSummaryModel>;
        })
    );
}

analyticsResponsesSummaryGet.PATH = '/api/v1/analytics/questionnaires/{questionnaireGuid}/responses/summary';
